import type { RouteRecordRaw } from 'vue-router';
import Permission from '@/composables/permissions/permissions';

export default [
  {
    path: 'answer-search',
    name: 'client-answer-search',
    component: () => import('./AnswerLookup.vue'),
    meta: {
      permissions: [Permission.ClientsSuppliersView],
    },
  },
] satisfies RouteRecordRaw[];
